import React, { memo, useState, useEffect, useCallback } from 'react'

import Popup from 'components/Popup'
import ApiError from 'api/ApiError'
import {
	Container,
	OkButton,
} from './FixedError.styles'

interface FixedErrorProps {
	error: ApiError
}

export default memo(function FixedError(
	{
		error,
	}: FixedErrorProps,
) {
	const [popupOpened, setPopupOpened] = useState(false)

	const errorMessage = error ? error.toString() : ''
	const [errorMessageCopy, setErrorMessageCopy] = useState()

	useEffect(() => {
		if (errorMessage) {
			if (errorMessageCopy !== errorMessage) {
				setErrorMessageCopy(errorMessage)
				setPopupOpened(true)
			}
		}
	}, [errorMessage, errorMessageCopy, setErrorMessageCopy, setPopupOpened])

	return (
		<Popup
			opened={popupOpened}
		>
			<Container>
				<p>
					{errorMessageCopy}
				</p>
				<OkButton
					onClick={
						useCallback(() => setPopupOpened(false), [])
					}
				>
					Ok
				</OkButton>
			</Container>
		</Popup>
	)
})
